import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { ClockIcon, SunIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const steps = [{
  day: 'Día 1',
  title: 'Descarga',
  description: 'Aplicás el protocolo de vaciado para sacar todos los pendientes de la cabeza y cerrar el ciclo de verdad.',
  icon: ClockIcon
}, {
  day: 'Día 2',
  title: 'Recarga',
  description: 'Seguís el protocolo de recuperación para bajar el cortisol y dormir profundo sin pensar en lo que viene.',
  icon: SunIcon
}, {
  day: 'Día 3',
  title: 'Blindaje',
  description: 'Ejecutás la primera hora blindada para dominar el día antes de que el día te domine a vos.',
  icon: ShieldCheckIcon
}];
export function HowItWorksSection() {
  return <section className="py-24 px-6 bg-charcoal-900" data-id="element-55">
      <div className="max-w-5xl mx-auto" data-id="element-56">
        <FadeIn data-id="element-57">
          <div className="mb-20 text-center" data-id="element-58">
            <div className="inline-flex items-center gap-3 bg-mutedred/10 border border-mutedred/30 px-5 py-2.5 rounded-full mb-6" data-id="element-59">
              <span className="w-2.5 h-2.5 rounded-full bg-mutedred animate-pulse" data-id="element-60"></span>
              <span className="text-mutedred text-sm font-medium tracking-wide" data-id="element-61">
                ⏰ Este precio cierra el domingo a las 23:59. Después sube a
                $19.990.
              </span>
            </div>

            <div className="flex flex-col items-center mb-6" data-id="element-62">
              <span className="block text-offwhite/60 text-sm uppercase tracking-widest mb-2" data-id="element-63">
                Acceso inmediato por solo
              </span>
              <span className="font-heading text-6xl sm:text-7xl text-amber drop-shadow-[0_0_15px_rgba(212,168,83,0.3)] mb-3 block" data-id="element-64">
                $9.990
              </span>
              <span className="text-offwhite/80 text-lg font-light" data-id="element-65">
                o{' '}
                <strong className="text-offwhite font-medium" data-id="element-66">
                  3 cuotas sin interés de $3.330
                </strong>
              </span>
            </div>

            <p className="text-mutedteal text-sm font-medium mb-6" data-id="element-67">
              🔥 Más de 500 personas ya aplicaron este protocolo este fin de
              semana.
            </p>

            <CTAButton className="w-full max-w-xl mb-4" data-id="element-68">
              EMPEZAR MI RESET ESTE FIN DE SEMANA
            </CTAButton>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-offwhite/60 text-sm mt-4" data-id="element-69">
              <span className="flex items-center gap-2" data-id="element-70">
                <ShieldCheckIcon className="w-4 h-4 text-mutedteal" data-id="element-71" /> Pago 100%
                seguro
              </span>
              <span className="flex items-center gap-2" data-id="element-72">
                <ZapIcon className="w-4 h-4 text-amber" data-id="element-73" /> Descarga instantánea
              </span>
              <span className="flex items-center gap-2" data-id="element-74">
                <ClockIcon className="w-4 h-4 text-mutedteal" data-id="element-75" /> Acceso de por
                vida
              </span>
            </div>
          </div>
        </FadeIn>

        <FadeIn data-id="element-76">
          <h2 className="font-heading text-4xl sm:text-5xl text-offwhite mb-16 text-center" data-id="element-77">
            Cómo funciona
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-78">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-[1px] bg-charcoal-700 z-0" data-id="element-79" />

          {steps.map((step, index) => {
          const Icon = step.icon;
          return <FadeIn key={index} delay={0.2 * index} className="relative z-10" data-id="element-80">
                <div className="flex flex-col items-center text-center" data-id="element-81">
                  <div className="w-24 h-24 bg-charcoal-800 rounded-full border-4 border-charcoal-900 flex items-center justify-center mb-6 shadow-xl" data-id="element-82">
                    <Icon className="w-10 h-10 text-amber" data-id="element-83" />
                  </div>
                  <span className="text-amber text-sm font-bold uppercase tracking-wider mb-2" data-id="element-84">
                    {step.day}
                  </span>
                  <h3 className="text-2xl font-heading text-offwhite mb-4" data-id="element-85">
                    {step.title}
                  </h3>
                  <p className="text-offwhite/70 font-light leading-relaxed" data-id="element-86">
                    {step.description}
                  </p>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}